<template>
  <vx-card style="padding-left: 10px">
    <div class="vx-col lg:w-1/2" align="left">
    </div>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        :sst="true"
        :total="totalDocs"
        :data="patients"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
        :max-items="dataTableParams.limit"
        search
        :noDataText="noDataText"
      >
        <div slot="header" class="flex flex-wrap-reverse flex-grow justify-between">
          <div style="float: left">
            <vs-select
              placeholder="10"
              vs-multiple
              autocomplete
              v-model="dataTableParams.limit"
              class="mr-6"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="treatmentType">Treatment Type</vs-th>
          <vs-th sort-key="unit">Unit</vs-th>
          <vs-th sort-key="createdAt">Created At</vs-th>
          <vs-th sort-key="isAvailable">Status</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{
              data[indextr].name
              }}
            </vs-td>
            <vs-td :data="data[indextr].treatmentType">
              {{
              data[indextr].treatmentDetail ? data[indextr].treatmentDetail.name : "N/A"
              }}
            </vs-td>
            <vs-td :data="data[indextr].unit">
              {{
              data[indextr].unit
              }}
            </vs-td>
            <vs-td :data="data[indextr].createdAt">{{ data[indextr].createdAt | date_formatter }}</vs-td>
            <vs-td :data="data[indextr].isAvailable"><span v-if="data[indextr].isAvailable">Available</span><span v-else>Not Available</span></vs-td>
            <vs-td :data="data[indextr]._id">
              <vx-tooltip text="View/Edit Product" position="left" >

                <vs-button
                  type="border"
                  size="small"
                  @click="editProduct(data[indextr]._id)"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="mr-2"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip text="Edit Status" position="left">
                <vs-button
                  type="border"
                  size="small"
                  @click="openDeletePopup(data[indextr]._id,data[indextr].isAvailable)"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="mt-1"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <span class="mr-2">
        {{
        dataTableParams.page * dataTableParams.limit -
        (dataTableParams.limit - 1)
        }}
        -
        {{
        totalDocs - dataTableParams.page * dataTableParams.limit > 0
        ? dataTableParams.page * dataTableParams.limit
        : totalDocs
        }}
        of {{ totalDocs }}
      </span>
      <div class="pagination-div" v-if="serverResponded">
        <paginate
          :page-count="totalPage"
          :click-handler="handleChangePage"
          class="pagination"
          :page-range="9"
          :prevText="'<'"
          :nextText="'>'"
        ></paginate>
      </div>
    </div>
    <vs-popup :active.sync="popUpDelete" title="Change product status" >
      <p align="center">Are you sure you want to make this product <span v-if="popupData.isAvailable">unavailable</span><span v-else>available</span>?</p>
      <br />
      <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" vs-mt="6">
        <vs-col vs-type="flex" vs-align="left" vs-w="6">
          <div class="w-full m-5" align="right">
            <vs-button
              size="lg"
              color="primary"
              @click="deleteDetailHandler(popupData.id)"
            >Yes</vs-button>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="left" vs-w="6">
          <div class="w-full m-5">
            <vs-button size="lg" color="danger" @click="popUpDelete=false">Cancel</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
  </vx-card>
</template>

<script>
  export default {
    name: 'ProductList',
    components: {
    },
    props: ['patients', 'totalDocs', 'page', 'noDataText','popUpDeleteParent'],
    data() {
      return {
        popUpDelete: this.popUpDeleteParent,
        customerCSVurl: false,
        isMounted: false,
        currentPage: 1,
        popupData:{
          id:'',
          isAvailable:false,
        },
        dataTableParams: {
          search: '',
          sort: 'createdAt',
          dir: 'desc',
          page: 1,
          limit: 10,
        },
        limitOptions: [
          { text: '5', value: 5 },
          { text: '10', value: 10 },
          { text: '25', value: 25 },
          { text: '50', value: 50 },
          { text: '100', value: 100 },
        ],
        serverResponded: false,
        awaitingSearch: null,
      };
    },
    methods: {
      async fetchList() {
        this.$vs.loading();
        await this.$emit('fetchList', this.dataTableParams);
        this.serverResponded = true;
        this.$vs.loading.close();
      },
      editProduct(id) {
         this.$emit('editProductParent', id);
      },
      openDeletePopup(id,available){
        this.popupData.id=id;
        this.popupData.isAvailable=available;
        this.popUpDelete=true;
      },
      handleSearch(searching) {
        if (this.awaitingSearch) {
          clearTimeout(this.awaitingSearch);
          this.awaitingSearch = null;
        }
        this.awaitingSearch = setTimeout(() => {
          this.serverResponded = false;
          this.dataTableParams.search = searching;
          this.dataTableParams.page = 1;
          this.$refs.table.currentx = 1;
          this.fetchList();
        }, 500);
      },
      handleChangePage(page) {
        this.dataTableParams.page = page;
        this.fetchList();
      },
      handleSort(key, active) {
        this.serverResponded = false;
        this.dataTableParams.sort = key;
        this.dataTableParams.dir = active;
        this.dataTableParams.page = 1;
        this.$refs.table.currentx = 1;
        this.fetchList();
      },
      async deleteDetailHandler(id) {
        await this.$emit('deleteProduct', {id,dataTableParams:this.dataTableParams});
       this.popUpDelete=false;
      },
      exportCsvHandler() {
        this.exportCsv()
          .then(async res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'freshclinic-patients.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
    watch: {
      'dataTableParams.page': function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.dataTableParams.page = newVal;
          this.fetchList();
        }
      },
      'dataTableParams.limit': function(newlimit, oldLimit) {
        if (newlimit !== oldLimit) {
          this.serverResponded = false;
          this.dataTableParams.page = 1;
          this.dataTableParams.limit = newlimit;
          this.fetchList();
        }
      },
    },
    computed: {
      totalPage: function() {
        return this.totalDocs / this.dataTableParams.limit >
        parseInt(this.totalDocs / this.dataTableParams.limit)
          ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
          : parseInt(this.totalDocs / this.dataTableParams.limit);
      },
    },
    created() {
      this.noDataText = 'Loading...';
      this.fetchList();
    },
  };
</script>
